import React from 'react';
import PropTypes from 'prop-types';
import {TextInput} from '@/components/atoms';
import styles from '../RewardSetup.module.scss';

/**
 * RewardSetupCard component displays the reward setup section
 * Contains name and reward ID input fields
 *
 * @param {Object} props - Component props
 * @param {Object} props.formData - Form data containing name and rewardId
 * @param {Function} props.handleNameChange - Handler for name input changes
 * @param {string} props.nameError - Error message for name validation
 * @returns {JSX.Element} The rendered RewardSetupCard component
 */
const RewardSetupCard = ({
  formData,
  handleNameChange,
  nameError,
  isNameDisabled
}) => {
  return (
    <div
      className={`flex flex-col gap-4 rounded-lg p-6 ${styles.rewardSetup__card}`}
      data-testid='reward-setup-card'>
      <h3 className='pb-3 pt-3 text-base font-bold text-white'>
        Reward Setup*
      </h3>
      <div className='flex flex-row items-start gap-6'>
        <div>
          <TextInput
            className={`w-full text-sm placeholder:text-sm ${styles.rewardSetup__rewardName}`}
            value={formData.name || ''}
            onChange={handleNameChange}
            label='Name*'
            placeholderText='Add Name'
            error={nameError}
            isDark={true}
            disabled={isNameDisabled || !!formData.rewardId}
            id='reward-name'
            data-testid='text-input_reward-name'
          />
        </div>
        <div>
          <TextInput
            className={`w-full text-sm placeholder:text-sm ${styles.rewardSetup__rewardIdLabel}`}
            value={formData.rewardId || ''}
            onChange={() => {}} // Read-only
            label='Reward ID'
            disabled={true}
            placeholderText='Reward ID'
            isDark={true}
            id='reward-id'
            data-testid='text-input_reward-id'
          />
        </div>
      </div>
    </div>
  );
};

RewardSetupCard.propTypes = {
  formData: PropTypes.shape({
    name: PropTypes.string,
    rewardId: PropTypes.string
  }).isRequired,
  handleNameChange: PropTypes.func.isRequired,
  nameError: PropTypes.string,
  isNameDisabled: PropTypes.bool
};

export default React.memo(RewardSetupCard);
